// @flow

import $ from 'jquery'

const DATA: Array<{ rus: number, mat: number, mir: number }> = [
  { mat: 4227, mir: 4187, rus: 4198 },
  { mat: 4258, mir: 4192, rus: 4262 },
  { mat: 4256, mir: 4194, rus: 4199 },
  { mat: 4263, mir: 4195, rus: 4204 },
]

export const changeSelects = () => {
  const $btn = $('[data-action="to-test"]')

  const grade = Number($('[name="Grade"]').val())
  const discipline = String($('[name="Discipline"]').val())

  $btn.addClass('disabled')

  if (grade && discipline !== 'null' && discipline !== '') {
    $btn.removeClass('disabled')

    const course = DATA[grade - 1][discipline]
    $btn.attr('data-course', course)
  }
}
